/** Shared formatting for average rating stats (dashboard, admin). */
export function formatAverageRatingDisplay(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—'
  return value.toFixed(1)
}
